import { ScheduleChart } from "@/components/schedule/ScheduleChart";

export function Aikataulu() {
  return <ScheduleChart />;
}
